import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { IoMdSwap } from 'react-icons/io';
import { IoHelpCircleOutline } from "react-icons/io5";
import TabelaPadrao from '../TabelaPadrao/TabelaPadrao';
import BotaoPadrao from '../BotaoPadrao/BotaoPadrao';
import AvisoVazio from '../AvisoVazio/AvisoVazio';
import BotaoAdicionarVinculos from '../BotaoAdicionarVinculos';
import './TabelaPadraoDividida.css';

/**
 * Componente de Tabela Dividida que mostra duas tabelas lado a lado
 * @param {Object} props
 * @param {Object} props.tabelaEsquerda - Configuração da tabela do lado esquerdo
 * @param {string} props.tabelaEsquerda.titulo - Título da tabela esquerda
 * @param {Array} props.tabelaEsquerda.dados - Array de dados para a tabela esquerda
 * @param {Array} props.tabelaEsquerda.colunas - Configuração das colunas da tabela esquerda
 * @param {number} props.tabelaEsquerda.totalRegistros - Total de registros na tabela esquerda
 * @param {number} props.tabelaEsquerda.paginaAtual - Página atual da tabela esquerda
 * @param {number} props.tabelaEsquerda.tamanhoPagina - Tamanho da página da tabela esquerda
 * @param {Function} props.tabelaEsquerda.paginaAnterior - Função para navegar para página anterior
 * @param {Function} props.tabelaEsquerda.proximaPagina - Função para navegar para próxima página
 * @param {Function} props.tabelaEsquerda.irParaPagina - Função para ir para uma página específica
 * @param {Function} props.tabelaEsquerda.onAcao - Função chamada ao clicar no ícone de ação
 * @param {Function} props.tabelaEsquerda.iconeAcao - Ícone de ação para a tabela esquerda
 * @param {string} props.tabelaEsquerda.requiredRoleToEdit - Permissão necessária para editar
 * @param {JSX.Element} props.tabelaEsquerda.componenteCheckboxCabecalho - Componente customizado para o cabeçalho da coluna de checkbox
 * 
 * @param {Object} props.tabelaDireita - Configuração da tabela do lado direito
 * @param {string} props.tabelaDireita.titulo - Título da tabela direita
 * @param {Array} props.tabelaDireita.dados - Array de dados para a tabela direita
 * @param {Array} props.tabelaDireita.colunas - Configuração das colunas da tabela direita
 * @param {number} props.tabelaDireita.totalRegistros - Total de registros na tabela direita
 * @param {number} props.tabelaDireita.paginaAtual - Página atual da tabela direita
 * @param {number} props.tabelaDireita.tamanhoPagina - Tamanho da página da tabela direita
 * @param {Function} props.tabelaDireita.paginaAnterior - Função para navegar para página anterior
 * @param {Function} props.tabelaDireita.proximaPagina - Função para navegar para próxima página
 * @param {Function} props.tabelaDireita.irParaPagina - Função para ir para uma página específica
 * @param {Function} props.tabelaDireita.onAcao - Função chamada ao clicar no ícone de ação
 * @param {Function} props.tabelaDireita.iconeAcao - Ícone de ação para a tabela direita
 * @param {string} props.tabelaDireita.requiredRoleToEdit - Permissão necessária para editar
 * @param {JSX.Element} props.tabelaDireita.componenteCheckboxCabecalho - Componente customizado para o cabeçalho da coluna de checkbox
 * 
 * @param {Function} props.onClickEsquerda - Função a ser executada quando o botão de navegação esquerda for clicado
 * @param {Function} props.onClickDireita - Função a ser executada quando o botão de navegação direita for clicado
 * @param {boolean} props.exibeAcao - Indica se os botões de ação devem ser exibidos
 * @param {boolean} props.desabilitarEstiloBotaoEditar - Indica se o estilo do botão de editar deve ser desabilitado
 * @param {Array} props.ultimosAdicionadosIds - Array com os IDs dos últimos itens adicionados
 * @param {boolean} props.modeloNovo - Indica se o modelo novo de layout deve ser usado
 * @param {boolean} props.podeMoverParaDireita - Indica se é possível mover itens para a direita
 * @param {boolean} props.podeMoverParaEsquerda - Indica se é possível mover itens para a esquerda
 * @param {JSX.Element} props.headerContent - Conteúdo personalizado para o cabeçalho da tabela dividida
 */
export default function TabelaPadraoDividida({
    tabelaEsquerda,
    tabelaDireita,
    onClickEsquerda,
    onClickDireita,
    exibeAcao = true,
    desabilitarEstiloBotaoEditar = false,
    ultimosAdicionadosIds = [],
    modeloNovo = false,
    podeMoverParaDireita = false,
    podeMoverParaEsquerda = false,
    headerContent = null,
    classCustom = ''
}) {
    return (
        <div className={`tabelasDivididasContainer${modeloNovo ? " tabelasDivididasContainerModeloNovo" : ""} ${classCustom}`.trim()}>
            {modeloNovo && headerContent && (
                <div className="headerContainer">
                    {headerContent}
                </div>
            )}
            <div className={`tabelasGrid${modeloNovo ? " tabelasGridModeloNovo" : ""}`}>
                <div className={`tabelaContainer${modeloNovo ? " tabelaContainerModeloNovoEsquerda" : ""}`}>
                    {tabelaEsquerda.titulo && (
                        <TituloTabelaIndividual
                            onClick={onClickEsquerda}
                            exibeAcao={exibeAcao}
                            modeloNovo={modeloNovo}
                        >
                            {tabelaEsquerda.titulo}
                        </TituloTabelaIndividual>
                    )}

                    {tabelaEsquerda.dados.length === 0 && (
                        <AvisoVazio
                            icone={<IoHelpCircleOutline />}
                            mensagem={"Nenhum resultado foi encontrado."}
                        />
                    )}

                    {tabelaEsquerda.dados.length > 0 && (
                        <TabelaPadrao
                            dados={tabelaEsquerda.dados || []}
                            colunas={tabelaEsquerda.colunas || []}
                            totalRegistros={tabelaEsquerda.totalRegistros}
                            totalItems={tabelaEsquerda.totalRegistros}
                            paginaAtual={tabelaEsquerda.paginaAtual}
                            tamanhoPagina={tabelaEsquerda.tamanhoPagina}
                            paginaAnterior={tabelaEsquerda.paginaAnterior}
                            proximaPagina={tabelaEsquerda.proximaPagina}
                            onPaginaAnterior={tabelaEsquerda.paginaAnterior}
                            onProximaPagina={tabelaEsquerda.proximaPagina}
                            irParaPagina={tabelaEsquerda.irParaPagina}
                            onIrParaPagina={tabelaEsquerda.irParaPagina}
                            acaoPersonalizada={tabelaEsquerda.acaoPersonalizada || ((item) => {
                                if (tabelaEsquerda.acaoPersonalizada) {
                                    return tabelaEsquerda.acaoPersonalizada(item);
                                }
                                
                                return (
                                    <BotaoAdicionarVinculos
                                        adicionar={true} 
                                        onClick={(e) => {
                                            e && e.stopPropagation && e.stopPropagation();
                                            tabelaEsquerda.onAcao && tabelaEsquerda.onAcao(item);
                                        }}
                                    />
                                );
                            })}
                            idsSelecionados={tabelaEsquerda.idsSelecionados}
                            desabilitarEstiloBotaoEditar={desabilitarEstiloBotaoEditar}
                            ultimosAdicionadosIds={ultimosAdicionadosIds}
                            linhaDestaque={tabelaEsquerda.linhaDestaque}
                            loading={tabelaEsquerda.loading}
                            // Props de Checkbox
                            acaoCheckbox={tabelaEsquerda.acaoCheckbox}
                            selecionados={tabelaEsquerda.selecionados}
                            onSelecionar={tabelaEsquerda.onSelecionar}
                            componenteCheckboxCabecalho={tabelaEsquerda.componenteCheckboxCabecalho}
                            acaoCabecalho={tabelaEsquerda.acaoCabecalho}
                            getItemId={tabelaEsquerda.getItemId}
                            getItemDescription={tabelaEsquerda.getItemDescription}
                        />
                    )}
                </div>

                {modeloNovo && <div className="separadorVertical"></div>}

                <div className={`tabelaContainer${modeloNovo ? " tabelaContainerModeloNovoDireita" : ""}`}>
                    {tabelaDireita.titulo && (
                        <TituloTabelaIndividual
                            onClick={onClickDireita}
                            exibeAcao={exibeAcao}
                            modeloNovo={modeloNovo}
                        >
                            {tabelaDireita.titulo}
                        </TituloTabelaIndividual>
                    )}

                    {tabelaDireita.dados.length === 0 && (
                        <AvisoVazio
                            icone={<IoHelpCircleOutline />}
                            mensagem={"Nenhum resultado foi encontrado."}
                        />
                    )}

                    {tabelaDireita.dados.length > 0 && (
                        <TabelaPadrao
                            dados={tabelaDireita.dados || []}
                            colunas={tabelaDireita.colunas || []}
                            totalRegistros={tabelaDireita.totalRegistros}
                            totalItems={tabelaDireita.totalRegistros}
                            paginaAtual={tabelaDireita.paginaAtual}
                            tamanhoPagina={tabelaDireita.tamanhoPagina}
                            paginaAnterior={tabelaDireita.paginaAnterior}
                            proximaPagina={tabelaDireita.proximaPagina}
                            onPaginaAnterior={tabelaDireita.paginaAnterior}
                            onProximaPagina={tabelaDireita.proximaPagina}
                            irParaPagina={tabelaDireita.irParaPagina}
                            onIrParaPagina={tabelaDireita.irParaPagina}
                            acaoPersonalizada={tabelaDireita.acaoPersonalizada || ((item) => (
                                <BotaoAdicionarVinculos
                                    adicionar={false} // Sempre mostra ícone de remover para tabela direita
                                    onClick={(e) => {
                                        e && e.stopPropagation && e.stopPropagation(); 
                                        tabelaDireita.onAcao && tabelaDireita.onAcao(item);
                                    }}
                                />
                            ))}
                            desabilitarEstiloBotaoEditar={desabilitarEstiloBotaoEditar}
                            ultimosAdicionadosIds={ultimosAdicionadosIds}
                            linhaDestaque={tabelaDireita.linhaDestaque}
                            loading={tabelaDireita.loading}
                            // Props de Checkbox
                            acaoCheckbox={tabelaDireita.acaoCheckbox}
                            selecionados={tabelaDireita.selecionados}
                            onSelecionar={tabelaDireita.onSelecionar}
                            componenteCheckboxCabecalho={tabelaDireita.componenteCheckboxCabecalho}
                            acaoCabecalho={tabelaDireita.acaoCabecalho}
                            getItemId={tabelaDireita.getItemId}
                            getItemDescription={tabelaDireita.getItemDescription}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

const TituloTabelaIndividual = ({
    children,
    textoBotao = "Adicionar / Remover",
    onClick,
    exibeAcao,
    modeloNovo
}) => (
    <div className={`tabelaTituloContainer${modeloNovo ? " tabelaTituloContainerModeloNovo" : ""}`}>
        <h2 className="tabelaTituloText">{children}</h2>
        {exibeAcao && (
            <BotaoPadrao
                aoClicar={onClick}
                icone={<IoMdSwap />}
                texto={textoBotao}
                classeCustom="botao-adicionar-remover"
            />
        )}
    </div>
);
